const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string): boolean => EMAIL_REGEX.test(email);

export const EMAIL_VALIDATION_ERROR_MESSAGE = "Please enter a valid email address";
